import ActionTypeMappingsStore from '+/models/ActionTypeMappingStore';
import ActionTypeMapping from '+/models/ActionTypeMapping';

const defaultStore = { all: new ActionTypeMappingsStore([]), individual: {} };

// eslint-disable-next-line default-param-last
const actionTypeMappings = (store = defaultStore, action) => {
  const newStore = { ...store };

  switch (action.type) {
    case 'SET_ALL_ACTION_TYPE_MAPPINGS': {
      newStore.all = new ActionTypeMappingsStore(action.payload);
      break;
    }

    case 'SET_ACTION_TYPE_MAPPING': {
      const { data, id } = action.payload;
      const mapping = new ActionTypeMapping(data.errors ? { missing: true } : data);
      newStore.individual[id] = mapping;
      break;
    }

    case 'UPDATE_ACTION_TYPE_MAPPING': {
      const newAll = store.all.dup();
      newAll.updateActionTypeMapping(action.payload);
      newStore.all = newAll;
      break;
    }

    case 'ADD_ACTION_TYPE_MAPPING': {
      const newAll = store.all.dup();
      newAll.store.push(new ActionTypeMapping(action.payload));
      newStore.all = newAll;
      break;
    }

    case 'REMOVE_ACTION_TYPE_MAPPING': {
      const newAll = new ActionTypeMappingsStore(
        store.all.store.filter(mapping => mapping.id !== action.payload),
      );
      newStore.all = newAll;
      break;
    }

    default:
      break;
  }

  return newStore;
};

export default actionTypeMappings;
